import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectDateLabel: {
		id: 'software-releases-launch-card.version-dates.editable-date-picker.select-date-label',
		defaultMessage: 'Select date',
		description: 'Label shown on calendar as placeholder text',
	},
});
